/**
 * Creates a throttled function that limits the rate at which a function can be called.
 * The function will be called at most once per specified time limit.
 *
 * @param callbackFn - The function to throttle
 * @param limit - The time limit in milliseconds
 * @returns A throttled version of the callback function
 */
// `unknown` constrains the callback type T; this function returns T, not `unknown`.
// oxlint-disable-next-line anti-slop/no-unknown-returns
export function throttle<T extends (...args: unknown[]) => unknown>(callbackFn: T, limit: number): T {
  let wait = false;
  return ((...args: Parameters<T>) => {
    if (!wait) {
      callbackFn(...args);
      wait = true;
      setTimeout(() => {
        callbackFn(...args);
        wait = false;
      }, limit);
    }
  }) as T;
}
